import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { HeaderPage } from "../../../components/header-page/HeaderPage";

type DealerHeaderProps = {
  onExport: () => void;
  onDistributorTypes: () => void;
};

export const DealerHeader = (props: DealerHeaderProps) => {
  const { onExport, onDistributorTypes } = props;

  return (
    <HeaderPage
      title="Distribuidores"
      extraActions={[
        {
          label: "Exportar",
          icon: faFileExcel,
          actionKey: "excel-export",
          onClick: onExport,
          color: "success",
        },
        {
          label: "Categorías de Distribuidores",
          actionKey: "product-types",
          onClick: onDistributorTypes,
        },
      ]}
    />
  );
};
